import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=f87ea718&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=f87ea718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87ea718",
  null
  
)

export default component.exports